<template>
    <div>
        <h2>Obdarovaný</h2>
        <p class="subtitle">Jméno obdarovaného vyplníme na dárkový poukaz</p>
        <ssv-order-beneficiary-information-form ref="beneficiaryInformationForm"/>
    </div>
</template>

<script>
    import SsvOrderBeneficiaryInformationForm from './BeneficiaryInformationForm';

    export default {
        name: 'SsvOrderBeneficiaryInformationContainer',
        components: {
            SsvOrderBeneficiaryInformationForm,
        },
        methods: {
            validate() {
                this.$refs.beneficiaryInformationForm.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/beneficiary-information/BeneficiaryInformationContainer.vue